import { useQuery } from "@tanstack/react-query";
import { isAuthorized, type IsAuthorizedRequest } from "../api/auth";

export function useIsAuthorized(
  params: IsAuthorizedRequest,
  // Extra cache-key segments. Authorization for an action can flip when
  // the entity changes state (e.g. `assign_reviewers` exists only on
  // `submitted`), but action/entity_id/workflow stay constant — so the
  // caller must pass the state-bearing value (the suggestion status)
  // here, or the cached answer survives the transition for `staleTime`.
  extraKeys: ReadonlyArray<unknown> = [],
) {
  const { action, entity_type, entity_id, workflow } = params;
  return useQuery({
    queryKey: [
      "is-authorized",
      action,
      entity_type,
      entity_id,
      workflow,
      ...extraKeys,
    ],
    queryFn: async () => {
      const res = await isAuthorized(params);
      return res.is_authorized;
    },
    staleTime: 60_000,
  });
}
